










import { Vue, Component, Ref, Prop } from "vue-property-decorator";
import { Position } from "@/models/Position";
import { currentCompanyStore } from "@/store/typed";
import VGoogleMap from "@/components/VGoogleMap.vue";
import {
  PIN_ICON_FILL_COLOR,
  PIN_ICON_FILL_COLOR_SELECTED,
  PIN_ICON_STROKE_COLOR,
  PIN_ICON_STROKE_COLOR_SELECTED,
  PIN_ICON_SVG,
  PIN_ICON_ZOOMED_FILL_COLOR,
  PIN_ICON_ZOOMED_STROKE_COLOR,
} from "@/utils/Map";
import CompanyPlace from "@/models/CompanyPlace";

interface MapObject {
  id: string;
  selected: boolean;
}

@Component({
  components: {
    VGoogleMap,
  },
})
export default class Map extends Vue {
  @Prop({ required: false, default: false })
  readonly disableDefaultMapUI!: boolean;
  @Ref() readonly map!: VGoogleMap;

  private mapObjects: { [id: string]: MapObject } = {};
  private zoomedMapObject: any = null;

  mounted() {}

  getPinIcon(selected: boolean) {
    return {
      path: PIN_ICON_SVG,
      strokeColor: selected
        ? PIN_ICON_STROKE_COLOR_SELECTED
        : PIN_ICON_STROKE_COLOR,
      strokeOpacity: 1,
      strokeWeight: 2,
      fillColor: selected ? PIN_ICON_FILL_COLOR_SELECTED : PIN_ICON_FILL_COLOR,
      fillOpacity: 1,
      rotation: 0,
      scale: 0.8,
      anchor: new window.google.maps.Point(30, 30),
    };
  }

  getPinIconForZoomDetail() {
    return {
      path: PIN_ICON_SVG,
      strokeColor: PIN_ICON_ZOOMED_STROKE_COLOR,
      strokeOpacity: 1,
      strokeWeight: 2,
      fillColor: PIN_ICON_ZOOMED_FILL_COLOR,
      fillOpacity: 1,
      rotation: 0,
      scale: 0.8,
      anchor: new window.google.maps.Point(30, 30),
    };
  }

  buildMarkerOptions(place: CompanyPlace) {
    return {
      icon: this.getPinIcon(place.highlighted),
    };
  }

  buildMarkerOptionsForZoomDetail() {
    return {
      icon: this.getPinIconForZoomDetail(),
    };
  }

  addMarker(place: CompanyPlace) {
    this.map.addMarker(
      place.id,
      place.position,
      this.buildMarkerOptions(place)
    );
    this.mapObjects[place.id] = this.buildMapObjectFromCompanyPlace(place);
  }

  buildMapObjectFromCompanyPlace(place: CompanyPlace) {
    return { id: place.id, selected: place.highlighted };
  }

  centerOnPlaces(CompanyPlaces: CompanyPlace[]) {
    const path: Position[] = [];
    for (const place of CompanyPlaces) {
      path.push(place.position);
    }
    this.map.centerOnBounds(path);
  }

  centerOnPlace(CompanyPlace: CompanyPlace) {
    this.zoomedMapObject = CompanyPlace;
    this.map.updateMarker(
      CompanyPlace.id,
      CompanyPlace.position,
      this.buildMarkerOptionsForZoomDetail()
    );
    this.map.centerOnPosition(CompanyPlace.position);
  }

  get searchCompanyPlaces() {
    return currentCompanyStore.searchCompanyPlaces;
  }

  get companyPlaces() {
    return currentCompanyStore.companyPlaces;
  }

  centerOnMarkers() {
    this.restoreZoomedMapObject();

    if (this.searchCompanyPlaces?.length) {
      this.centerOnPlaces(this.searchCompanyPlaces);
    } else {
      if (this.companyPlaces?.length) {
        this.centerOnPlaces(this.companyPlaces);
      }
    }
  }

  updateMarker(place: CompanyPlace) {
    this.map.updateMarker(
      place.id,
      place.position,
      this.buildMarkerOptions(place)
    );
    this.mapObjects[place.id] = this.buildMapObjectFromCompanyPlace(place);
  }

  clearMarkers() {
    this.map.clearMarkers();
  }

  removeMarker(id: string) {
    this.map.removeMarker(id);
  }

  onMarkerClick(markerId: string) {
    if (this.$route.name === "company-poi-search") {
      this.mapObjects[markerId].selected = !this.mapObjects[markerId].selected;
      const companyPlace = new CompanyPlace();
      companyPlace.id = markerId;
      companyPlace.highlighted = this.mapObjects[markerId].selected;
      currentCompanyStore.updateSelectionCompanyPlace(companyPlace);
    }

    if (this.$route.name === "company-poi") {
      const companyPlace = currentCompanyStore.companyPlaces.find(
        (o) => o.id === markerId
      );
      if (companyPlace) {
        currentCompanyStore.openModalPoiDetails(companyPlace);
      }
    }
  }

  restoreZoomedMapObject() {
    if (this.zoomedMapObject) {
      const companyPlace = this.zoomedMapObject as CompanyPlace;
      this.map.updateMarker(
        companyPlace.id,
        companyPlace.position,
        this.buildMarkerOptions(companyPlace)
      );
    }
  }
}
